import { register } from "@rill/loader";

register(
  {
    name: "tasks",
    meta: ["tasks"],
  },
  async (
    { api, locals },
    { tab, completed = false, filterGroup, organizationCoach = undefined }
  ) => {
    let query = { type: tab, completed, filterGroup };
    const organizationRoleName = locals.organizationRoleName;
    const isAllowToLoadAllAthletes =
      organizationRoleName &&
      (organizationRoleName === "Admin" || organizationRoleName === "Owner");
    let endpoint = "tasks";
    if (organizationCoach) {
      query = { ...query, organizationCoach };
    }

    if (locals.activeUser.organizationId && isAllowToLoadAllAthletes) {
      endpoint = "organization-tasks";
    }
    const res = await api(endpoint, {
      query,
    });
    const resJSON = await res.json();
    return resJSON;
  }
);
